// Human-readable tile naming for DOM copy ("3 Circles", "Red Dragon") — split
// out of CoachPanel to stay under the 200-line cap. i18next v26's typed `t`
// rejects `string` keys, and the coach's discard/claim reason keys are
// runtime-selected, so `translate` narrows through an alias (domino does the
// same in its notation layer).

import { t } from '../i18n/I18n.js';
import type { Honor, Suit, Tile } from '../game/types.js';

// Literal-typed so the values stay valid i18next keys the typed `t` accepts.
const SUIT_LABEL_KEY = {
  man: 'tile.suitMan',
  pin: 'tile.suitPin',
  sou: 'tile.suitSou',
} as const satisfies Record<Suit, string>;

const HONOR_LABEL_KEY = {
  east: 'tile.windEast',
  south: 'tile.windSouth',
  west: 'tile.windWest',
  north: 'tile.windNorth',
  white: 'tile.dragonWhite',
  green: 'tile.dragonGreen',
  red: 'tile.dragonRed',
} as const satisfies Record<Honor, string>;

export const translate = t as unknown as (key: string, params?: Record<string, unknown>) => string;

/** Human-readable tile name via i18n — "3 Circles", "Red Dragon". */
export function tileName(tile: Tile): string {
  if (tile.kind === 'honor') return t(HONOR_LABEL_KEY[tile.honor]);
  return t('coach.tileName', { rank: tile.rank, suit: t(SUIT_LABEL_KEY[tile.suit]) });
}
